import { createContext } from 'react';
import { Language } from '../types/Language';
var LanguageContext = /*#__PURE__*/createContext({
  language: Language.ENGLISH,
  setLanguage: function (language) {}
});
export default LanguageContext;